import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { GetVoidProyectoBusqueda, ProyectoBusqueda } from '../../interfaces/ProyectoBusqueda';
import { DataBsqProy } from '../../interfaces/DataBsqProy';
import {HiOutlineDocumentSearch} from 'react-icons/hi';
import {Grid, IconButton, Tooltip} from '@mui/material';
import {format} from 'date-fns';
import { DetallesProyecto, getVoidDetallesProyecto } from '../../interfaces/DetallesProyecto';
import ProyectoService from '../../services/ProyectoService';
import { DetalleProyectoGeneralModal } from './DetalleProyectoGeneral';
import { MdEditNote } from "react-icons/md";
import { IoDocumentAttachOutline } from "react-icons/io5";
import { FaRegClipboard } from "react-icons/fa";
import { PiStudentFill } from "react-icons/pi";
import { GiNotebook } from "react-icons/gi";
import AyudantiaService from '../../services/AyudantiaService';
import { AyudTesisPeriodoDTO, VoidAyudTesisPeriodoDTO } from '../../interfaces/ayudantias/AyudTesisPeriodo';
import { CasUserContext } from '../../services/casUserContext';
import { PeriodoAcademicoDTO, VoidPeriodoAcademicoDTO } from '../../interfaces/SAAC/PeriodoAcademicoDTO';
import AcademicoService from '../../services/AcademicoService';
import { Spinner } from 'reactstrap';

interface Column {
  id: 'code' | 'title' | 'director' | 'inicio' | 'fin' | 'estado' | 'opcions';
  label: string;
  minWidth?: number;
  align?: 'right';
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: 'code', label: 'Código', minWidth: 170 },
  { id: 'title', label: 'Titulo', minWidth: 100 },
  { id: 'director', label: 'Responsable', minWidth: 170},
  {
    id: 'inicio',
    label: 'Fecha Inicio',
    minWidth: 85,
  },
  {
    id: 'fin',
    label: 'Fecha Fin',
    minWidth: 85,
  },
  {
    id: 'estado',
    label: 'Estado',
    minWidth: 170,
  },
  {
    id: 'opcions',
    label: 'Opciones',
    minWidth: 170,
  },
];

interface Data {
  name: string;
  code: string;
  population: number;
  size: number;
  density: number;
}

function createData(
  name: string,
  code: string,
  population: number,
  size: number,
): Data {
  const density = population / size;
  return { name, code, population, size, density };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    zIndex:0,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    zIndex:-1,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const proyectoService = new ProyectoService();
const ayudantiaService = new AyudantiaService();
const academicoService = new AcademicoService

export default function BusqProyTable(props: DataBsqProy) {
  let history = useNavigate();
  const casUserContext = React.useContext(CasUserContext);
  const token = casUserContext.token;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(props.rowsPerPage[0]);
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
  const [modalData, setModalData] = React.useState<ProyectoBusqueda>(GetVoidProyectoBusqueda());
  const [detalleData, setDetalleData] = React.useState<DetallesProyecto>(getVoidDetallesProyecto());
  let [fechasAyu,setFechasAyu] = React.useState<AyudTesisPeriodoDTO>(VoidAyudTesisPeriodoDTO());
  const [periodoActivo, setPeriodoActivo] = React.useState<PeriodoAcademicoDTO>(VoidPeriodoAcademicoDTO());
  const [ready, setReady] = React.useState(false);

  //#region Funciones 
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const goToNavigation = (site:string) =>{
    history(site)
  }
  const handleSearchDetalle = async (id:number) =>{
    try{
      await proyectoService.GetDetalleProyectoById(id,props.token)
              .then((data) => {
                  //console.log(data);
                  setDetalleData(data.data);
              })
              .catch((error) => {
                console.error(error)
              });
    }catch(error){
      console.error('Error:',error);
    }
  };
  const GetPeriodo = async () => {
    await academicoService.GetPeriodoAcademicoEnEjecucion(token)
        .then((data) => {
            setPeriodoActivo(data.data)
            setReady(true);
        })
        .catch((error) => console.error(error));
};
  function ProyectosAprobados(row: ProyectoBusqueda):boolean{
    let bandera = row.estado != "Proyecto en la bandeja del director. Proyecto Nuevo.";
    return bandera;
  }
  function ProyectosEnEjecucion(row: ProyectoBusqueda):boolean{
    let bandera = row.estado == "En ejecución. Proyecto Aprobado";
    return bandera;
  }
  function DentroPeriodoAyudantias():boolean{
    let bandera = false;
    const today = new Date();
    if(fechasAyu.estado === 1){
      const fechaInicio = new Date(fechasAyu.fechaAperturaAyud);
      const fechaFin = new Date(fechasAyu.fechaCierreAyud);
      bandera = today >= fechaInicio && today <= fechaFin;
    }    
    return bandera;
  }
  function DentroPeriodoItinerarias():boolean{
    let bandera = false;
    const today = new Date();
    if(fechasAyu.estado === 1){
      const fechaInicio = new Date(fechasAyu.fechaAperturaTesis);
      const fechaFin = new Date(fechasAyu.fechaCierreTesis);
      bandera = today >= fechaInicio && today <= fechaFin;
    }
    return bandera;
  }
  function ProyectosTodoElPeriodo(inicio: string, fin: string):boolean{
    let bandera = false;
    if(periodoActivo.fechainicio){
      const fechaInicio = new Date(periodoActivo.fechainicio);
      const fechaFin = new Date(periodoActivo.fechafin);
      const inicioPro = new Date(inicio);
      const finPro = new Date(fin);
      // console.log(fechaInicio)
      // console.log(fechaFin)
      // console.log(inicioPro)
      // console.log(finPro)
      bandera = inicioPro <= fechaInicio &&  fechaFin <= finPro;
    }
    return bandera;
  }
  const handleOpenModal = async (data: ProyectoBusqueda) => {
    await handleSearchDetalle(data.idProyecto);
    setModalData(data);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const fetchData = async () =>{
    try{
      await ayudantiaService.GetFechaAperturaCierreAyudTesis(token)
      .then((data) => {
        if(data.status.isSuccessfully){
          setFechasAyu(data.data);
          //console.log(data.data);
          GetPeriodo();
        }else{
          setFechasAyu(VoidAyudTesisPeriodoDTO());
        }
      })
      .catch((error) => console.error(error));
    }catch(error){
      console.error('Error:',error);
    }
  };
  React.useEffect(() => {
    fetchData();
    },[]);
  //#endregion
  return (
    <>
    {ready ?
    <Paper sx={{ width: '100%', overflow: 'hidden', minHeight:'50vh' }}>
      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
            {columns.map((column) => (                
                <StyledTableCell 
                      style={{ minWidth: column.minWidth }}
                      key={column.id}
                      align={column.align}>
                  {column.label}
                  </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.length > 0 ? props.data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <StyledTableRow key={row.idProyecto}>
              <StyledTableCell component="th" scope="row">
                {row.codigo}
              </StyledTableCell>
              <StyledTableCell align="left">{row.titulo}</StyledTableCell>
              <StyledTableCell align="left">{row.responsable}</StyledTableCell>
              <StyledTableCell align="left">{format(new Date(row.fechaInicio),'dd/MMM/yyyy')}</StyledTableCell>
              <StyledTableCell align="left">{format(new Date(row.fechaFin),'dd/MMM/yyyy')}</StyledTableCell>
              <StyledTableCell align="left">{row.estado}</StyledTableCell>
              <StyledTableCell align="left">
                <Grid>
                  { ProyectosAprobados(row) ? 
                  <Tooltip title={"Detalle"} placement="top" arrow >
                    <IconButton aria-label="Detalle" color="primary" onClick={() => handleOpenModal(row)}>
                      <HiOutlineDocumentSearch />
                    </IconButton>
                  </Tooltip> 
                  :<></>}
                 {false ?
                      <Tooltip title={"Editar"} placement="top" arrow >
                        <IconButton aria-label="Adjuntar" color="secondary" onClick={() => goToNavigation('/Proyecto/'+row.idProyecto)}>
                          <MdEditNote />
                        </IconButton>
                      </Tooltip>
                    :<></>
                 }
                 {ProyectosEnEjecucion(row) ?
                      <Tooltip title={"Adjuntar Producto"} placement="top" arrow >
                        <IconButton aria-label="Adjuntar" color="secondary" onClick={() => goToNavigation('/Producto/ProductosProyectoEspol/'+row.idProyecto)}>
                          <IoDocumentAttachOutline />
                        </IconButton>
                      </Tooltip>
                    : <></>}
                  {ProyectosEnEjecucion(row) && DentroPeriodoItinerarias() && ProyectosTodoElPeriodo(row.fechaInicio, row.fechaFin) ?
                      <Tooltip title={"Itinerario"} placement="top" arrow >
                        <IconButton aria-label="Itinerario" color="secondary" onClick={() => goToNavigation('/Proyecto/itinerario/'+row.idProyecto)}>
                          <PiStudentFill />
                        </IconButton>
                      </Tooltip>
                    : <></>}
                    {ProyectosEnEjecucion(row) && DentroPeriodoAyudantias() && ProyectosTodoElPeriodo(row.fechaInicio, row.fechaFin) ?
                      <Tooltip title={"Ayudantias"} placement="top" arrow >
                        <IconButton aria-label="Ayudantias" color="secondary" onClick={() => goToNavigation('/Proyecto/ayudantia/'+row.idProyecto)}>
                          <GiNotebook />
                        </IconButton>
                      </Tooltip>
                    : <></>}
                  {false ?
                      <Tooltip title={"Solicitud"} placement="top" arrow >
                        <IconButton aria-label="Adjuntar" color="secondary" onClick={() => goToNavigation('/Solicitudes/nuevaSolicitud/'+row.idProyecto)}>
                          <FaRegClipboard />
                        </IconButton>
                      </Tooltip>
                    :<></>
                  }
                </Grid>
              </StyledTableCell>
            </StyledTableRow>
                );
              }):
              <StyledTableRow key={0}>
              <StyledTableCell component="th" scope="row">
                {'FAC-NUM-AÑO'}
              </StyledTableCell>
              <StyledTableCell align="left">{'No hubo resultados'}</StyledTableCell>
              <StyledTableCell align="left">{'Nadie'}</StyledTableCell>
              <StyledTableCell align="left">{format(new Date(),'dd/MMM/yyyy')}</StyledTableCell>
              <StyledTableCell align="left">{format(new Date(),'dd/MMM/yyyy')}</StyledTableCell>
              <StyledTableCell align="left">{'No se ha consultado nada'}</StyledTableCell>
              <StyledTableCell align="left"></StyledTableCell>
            </StyledTableRow>
              }
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={props.rowsPerPage}
        component="div"
        count={props.data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <DetalleProyectoGeneralModal isOpen={isModalOpen} onClose={handleCloseModal} data={modalData} detalle={detalleData}/>
    </Paper>
    :
    <Spinner
      color="primary"
      style={{
        height: '3rem',
        width: '3rem'
      }}
      >
        Loading...
      </Spinner>
    }
    </>
  );
}